import React from 'react';
import { motion } from 'framer-motion';
import { Download, Edit3, BarChart2 } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: Download,
    title: 'Accede a Orden Financiero™',
    description: 'Recibirás acceso inmediatamente después de completar tu compra.'
  }, {
    icon: Edit3,
    title: 'Carga tus datos',
    description: 'Ingresa tus ingresos, gastos, ahorros y deudas en los espacios indicados.'
  }, {
    icon: BarChart2,
    title: 'Visualiza tu situación',
    description: 'Los gráficos, resúmenes y paneles te permitirán entender rápidamente dónde estás y qué puedes mejorar.'
  }];
  return <section className="py-10 md:py-20 bg-white" data-id="element-82" data-mp="gss1ygeqwton">
      <div className="container mx-auto px-4 md:px-6" data-id="element-83" data-mp="gr73wgt82sm1">
        <div className="text-center mb-8 md:mb-16" data-id="element-84" data-mp="14i30dr8mibzm">
          <h2 className="font-display text-2xl md:text-4xl font-extrabold text-stone-900 tracking-tight mb-2 md:mb-4" data-id="element-85" data-mp="199uj5fljfdf7">
            ¿Cómo funciona?
          </h2>
          <p className="text-sm md:text-base text-stone-600" data-id="element-86" data-mp="2rm7f0re617au">
            Tres simples pasos para pasar del desorden a la claridad.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-4 md:gap-8 relative" data-id="element-87" data-mp="31bzgm5kon0ot">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-stone-200 -z-10" data-id="element-88" data-mp="2wjpr2qnhc2n2" />

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="flex flex-col items-center text-center bg-white p-2 md:p-4" data-id="element-89" data-mp="3ae0bivsg1anb" data-mpi={index}>
              <div className="relative mb-3 md:mb-6" data-id="element-90" data-mp="1kzbvmkkn9akj">
                <div className="w-16 h-16 md:w-24 md:h-24 bg-[#fafaf9] rounded-full flex items-center justify-center border-4 border-white shadow-lg" data-id="element-91" data-mp="3l0ii8a9gtssb">
                  <step.icon className="w-6 h-6 md:w-10 md:h-10 text-[#10b981]" data-id="element-92" data-mp="3q0el266ffe6a" />
                </div>
                <span className="absolute -top-1 -right-1 md:top-0 md:right-0 w-6 h-6 md:w-8 md:h-8 rounded-full bg-teal-600 text-white font-display text-xs md:text-sm font-bold flex items-center justify-center shadow-md" data-id="element-93" data-mp="2tueoou2ddor">
                  {index + 1}
                </span>
              </div>
              <h3 className="font-display text-base md:text-xl font-bold text-stone-900 mb-1.5 md:mb-3" data-id="element-94" data-mp="cpp5i78fyf2m">
                {step.title}
              </h3>
              <p className="text-xs md:text-base text-stone-600 max-w-xs" data-id="element-95" data-mp="lj249pt6sawm">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}